import { createAsyncThunk } from "@reduxjs/toolkit";
import type { AxiosError, AxiosRequestConfig } from "axios";
import { CategoryService } from "../../../services/CategoryService";
import { getDefaultCategories } from "../AsideRoutes";
import {
  CategoryInterface,
  ExtendedCategoryInterface,
} from "../../../entities/Category";

export const fetchAsideCategories = createAsyncThunk<
  ExtendedCategoryInterface[],
  AxiosRequestConfig,
  { rejectValue: AxiosError }
>(
  "category/asideCategories",
  async (params: AxiosRequestConfig, { rejectWithValue }) => {
    try {
      const response = await CategoryService.getCategories(params);
      const { data } = response;
      const defaultMappedCategories = new Map(
        getDefaultCategories().map((item) => [item.id, item]),
      );

      const combinedCategories: ExtendedCategoryInterface[] = data.map(
        (item: CategoryInterface) => ({
          ...item,
          activeImg: defaultMappedCategories.get(item.id)?.inactive,
          inactiveImg: defaultMappedCategories.get(item.id)?.active,
          to: defaultMappedCategories.get(item.id)?.to || "/not-found",
        }),
      );

      return [...combinedCategories];
    } catch (e: any) {
      return rejectWithValue(e.message as AxiosError);
    }
  },
);
